import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-733b91a2")

_pushScopeId("data-v-733b91a2")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-between h-screen right-container" }
const _hoisted_3 = { class: "flex-grow flex flex-col items-start bg-primary-100 overflow-y-scroll px-12 pt-12" }
const _hoisted_4 = { class: "bg-white hidden lg:flex flex-col mb-4 mx-auto px-4 py-3 rounded-md" }
const _hoisted_5 = { class: "flex flex-row justify-between gap-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "新しい独自アプリを登録", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "メインボタン設定", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "アプリロゴ設定", -1)
const _hoisted_9 = { class: "panel-container rounded-md bg-white pb-2 mb-16" }
const _hoisted_10 = { class: "flex items-center w-full table-header-color px-4 py-3" }
const _hoisted_11 = { class: "mr-2" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "独自アプリ取得中...", -1)
const _hoisted_14 = { class: "hidden lg:flex justify-end items-center" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 選択した独自アプリを削除 ")
const _hoisted_16 = { class: "mr-6 text-gray-500 text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_loading_icon = _resolveComponent("m-loading-icon")
  const _component_m_table = _resolveComponent("m-table")
  const _component_MMiniAppAddModal = _resolveComponent("MMiniAppAddModal")
  const _component_MMiniAppEditModal = _resolveComponent("MMiniAppEditModal")
  const _component_MMainButtonSettingEditModal = _resolveComponent("MMainButtonSettingEditModal")
  const _component_MLogoSettingEditModal = _resolveComponent("MLogoSettingEditModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_MNavBar),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_MHeaderPanel, {
          title: "独自アプリ管理",
          breadcrumbs: []
        }),
        _createVNode("main", _hoisted_3, [
          _createVNode("section", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_m_button, {
                color: "primary-500",
                "hover-color": "primary-600",
                onClick: _ctx.showAddModal
              }, {
                default: _withId(() => [
                  _createVNode(_component_m_icon, {
                    type: "plus",
                    width: "4",
                    class: "mr-2"
                  }),
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_m_button, {
                color: "primary-500",
                "hover-color": "primary-600",
                onClick: _ctx.showMainButtonSettingEditModal
              }, {
                default: _withId(() => [
                  _createVNode(_component_m_icon, {
                    type: "pencil",
                    width: "4",
                    class: "mr-2"
                  }),
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]),
              (!_ctx.isAdmin)
                ? (_openBlock(), _createBlock(_component_m_button, {
                    key: 0,
                    color: "primary-500",
                    "hover-color": "primary-600",
                    onClick: _ctx.showLogoSettingEditModal
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_m_icon, {
                        type: "pencil",
                        width: "4",
                        class: "mr-2"
                      }),
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("section", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKeyword = $event)),
                  type: "search",
                  name: "searchMiniApp",
                  placeholder: "名称、URLで検索...",
                  class: "w-44 md:w-60 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-2 leading-8 transition-colors duration-300"
                }, null, 512), [
                  [_vModelText, _ctx.searchKeyword]
                ])
              ])
            ]),
            (_ctx.load)
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  _createVNode(_component_m_loading_icon),
                  _hoisted_13
                ]))
              : (_openBlock(), _createBlock(_component_m_table, {
                  key: 1,
                  datas: _ctx.filteredApps,
                  definitions: _ctx.definitions,
                  "count-per-page": 40,
                  "default-sort-key": "name",
                  editable: true,
                  selectable: "",
                  "selected-ids": _ctx.selectedIds,
                  onChange: _ctx.changeSelectedId,
                  onSelect: _ctx.showEditModal
                }, {
                  footer: _withId(() => [
                    _createVNode("div", _hoisted_14, [
                      _createVNode(_component_m_button, {
                        color: "red-400",
                        "hover-color": "red-500",
                        outline: "",
                        class: "mr-6",
                        disabled: _ctx.selectedIds.length === 0,
                        onClick: _ctx.deleteApps
                      }, {
                        default: _withId(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _createVNode("p", _hoisted_16, _toDisplayString(_ctx.selectedIds.length) + "個を選択中 ", 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["datas", "definitions", "selected-ids", "onChange", "onSelect"]))
          ])
        ])
      ])
    ]),
    (_ctx.isDisplayedAddMiniAppModal)
      ? (_openBlock(), _createBlock(_component_MMiniAppAddModal, {
          key: 0,
          "mini-apps": _ctx.miniApps,
          students: _ctx.accessibleStudents,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDisplayedAddMiniAppModal = false))
        }, null, 8, ["mini-apps", "students"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayedEditSchoolModal)
      ? (_openBlock(), _createBlock(_component_MMiniAppEditModal, {
          key: 1,
          "app-id": _ctx.selectedId,
          "mini-apps": _ctx.miniApps,
          "mini-app": _ctx.selectedMiniApp,
          students: _ctx.accessibleStudents,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDisplayedEditSchoolModal = false))
        }, null, 8, ["app-id", "mini-apps", "mini-app", "students"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayedMainButtonSettingEditModal)
      ? (_openBlock(), _createBlock(_component_MMainButtonSettingEditModal, {
          key: 2,
          "main-button-setting": _ctx.mainButtonSettingList,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDisplayedMainButtonSettingEditModal = false))
        }, null, 8, ["main-button-setting"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayedLogoSettingEditModal)
      ? (_openBlock(), _createBlock(_component_MLogoSettingEditModal, {
          key: 3,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isDisplayedLogoSettingEditModal = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
})